export enum AttributionEffectEventType {
  Order = "order",
}
